// Domain model — frontend-safe surface. NEVER export repositories or
// drizzle tables here; those live in ../persistence and the sample
// hono-shared lib respectively.
export * from './note';
